import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import MinimalFooter from '../../components/common/footer/MinimalFooter';

import '../../stylesheets/pages/SignupIntentPage.less';
import { setBusinessUnit } from '../../actions/AuthActions';

class SignupIntentPage extends Component {
  // This page is pre-auth.
  constructor(props) {
    super(props);
    this.handleSetProduct = this.handleSetProduct.bind(this);
  }

  handleSetProduct(businessUnit) {
    this.props.onSetProduct(businessUnit);
  }

  render() {
    const { businessUnit } = this.props;
    return (
      <div className="signup-intent-page">
        <Helmet
          style={[
            {
              type: 'text/css',
              cssText: ` html, .main-content {
                background: #FCFCFC;
              }
              body {
                margin-bottom: 75px;
              }`
            }
          ]}
        />
        <header className="minimal-header">
          <a href="/" target="_self" className="visible-xs visible-sm"><i className="zolaicon zolaicon-chevron-left" /></a>
          <a href="/" target="_self">
            <div className="zola-logo-horizontal-black center-block" />
          </a>
        </header>
        <a href="/" className="onboard-back-button hidden-xs hidden-sm">
          <button className="btn btn-sm btn-round btn-secondary">&lsaquo; Back</button>
        </a>
        <div className="container">
          <div className="row">
            <div className="text-h1 intent-title col-xs-12 text-center">
              Where would you like to start?
            </div>
          </div>
          <div className="row signup-products-container">
            <div className="signup-product-row col-xs-12 col-md-6">
              <div className={`signup-product ${(businessUnit === 'REGISTRY') && 'active'}`}>
                <div className="product-circle" >
                  <div className="product-image-container">
                    <Link to="/onboard/signup?product=REGISTRY" className="product-image-container tag-signup-intent-registry" id="tag-signup-intent-registry" onClick={() => this.handleSetProduct('REGISTRY')}>
                      <img src="/images/onboard/registry-gift-doodle.svg" alt="Signup for a Wedding Registry" />
                    </Link>
                  </div>
                </div>
                <Link to="/onboard/signup?product=REGISTRY" className="signup-product-title center-block text-center" onClick={() => this.handleSetProduct('REGISTRY')}>
                  REGISTRY
                </Link>
              </div>
              <div className={`signup-product ${(businessUnit === 'WEDDING_WEBSITE') && 'active'}`}>
                <div className="product-circle">
                  <Link to="/onboard/signup?product=WEDDING_WEBSITE" className="product-image-container tag-signup-intent-website" id="tag-signup-intent-website" onClick={() => this.handleSetProduct('WEDDING_WEBSITE')}>
                    <img src="/images/onboard/website-laptop-doodle.svg" alt="Signup for a Wedding Website" />
                  </Link>
                </div>
                <Link to="/onboard/signup?product=WEDDING_WEBSITE" className="signup-product-title center-block text-center" onClick={() => this.handleSetProduct('WEDDING_WEBSITE')}>
                  <span className="visible-xs">WEDDING<br />WEBSITE</span>
                  <span className="hidden-xs">WEDDING WEBSITE</span>
                </Link>
              </div>
            </div>
            <div className="signup-product-row col-xs-12 col-md-6">
              <div className={`signup-product ${(businessUnit === 'INVITATIONS') && 'active'}`}>
                <div className="product-circle">
                  <div className="product-image-container">
                    <Link to="/onboard/signup?product=INVITATIONS" className="product-image-container tag-signup-intent-invites" id="tag-signup-intent-invites" onClick={() => this.handleSetProduct('INVITATIONS')}>
                      <img src="/images/onboard/invites-envelope-doodle.svg" alt="Signup for Save the Dates and Invites" />
                    </Link>
                  </div>
                </div>
                <Link to="/onboard/signup?product=INVITATIONS" className="signup-product-title center-block text-center" onClick={() => this.handleSetProduct('INVITATIONS')}>
                  <span className="visible-xs">SAVE THE DATES<br />&#43; INVITES</span>
                  <span className="hidden-xs">SAVE THE DATES &#43; INVITES</span>
                </Link>
              </div>
              <div className={`signup-product ${(businessUnit === 'WEDDING_CHECKLIST') && 'active'}`}>
                <div className="product-circle">
                  <div className="product-image-container">
                    <Link to="/onboard/signup?product=WEDDING_CHECKLIST" className="product-image-container tag-signup-intent-checklist" id="tag-signup-intent-checklist" onClick={() => this.handleSetProduct('WEDDING_CHECKLIST')}>
                      <img src="/images/onboard/checklist-doodle.svg" alt="Signup for a Wedding Checklist" />
                    </Link>
                  </div>
                </div>
                <Link to="/onboard/signup?product=WEDDING_CHECKLIST" className="signup-product-title center-block text-center" onClick={() => this.handleSetProduct('WEDDING_CHECKLIST')}>
                  <span className="visible-xs">WEDDING<br />CHECKLIST</span>
                  <span className="hidden-xs">WEDDING CHECKLIST</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <MinimalFooter />
      </div>
    );
  }
}

SignupIntentPage.propTypes = {
  onSetProduct: PropTypes.func,
  businessUnit: PropTypes.oneOf(['REGISTRY', 'WEDDING_WEBSITE', 'INVITATIONS', 'WEDDING_CHECKLIST']),
};

const mapStateToProps = state => ({
  businessUnit: state.auth.businessUnit
});

const mapDispatchToProps = dispatch => ({
  onSetProduct: businessUnit => dispatch(setBusinessUnit(businessUnit)),
});

const SignupIntent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupIntentPage);

export default SignupIntent;



/** WEBPACK FOOTER **
 ** ./src/pages/preauth/SignupIntentPage.jsx
 **/